import {
  OutlineCalendarCheckIcon,
  OutlineClock_endIcon,
  OutlineUsersIcon,
} from '@tempmee/react-icons';
import type { ITestimonial, IValueProp } from './AuthLeftPanel';

const ICON_SIZE = 30;

export const VALUE_PROPS: IValueProp[] = [
  {
    icon: <OutlineUsersIcon size={ICON_SIZE} />,
    text: '200,000+ verified professionals, with insurance coverage and payments handled by GoTu',
  },
  {
    icon: <OutlineClock_endIcon size={ICON_SIZE} />,
    text: 'Find coverage fast, offices often receive applications within seconds',
  },
  {
    icon: <OutlineCalendarCheckIcon size={ICON_SIZE} />,
    text: 'Almost 750,000 shifts covered, helping offices see more patients',
  },
];

export const TESTIMONIALS: ITestimonial[] = [
  {
    quote:
      'I am a practice manager for two locations and GoTu has been a life savior for me this past year. They have consistently helped me cover shifts several times per month.',
    author: 'Christy F.',
    role: 'Operations Manager',
  },
  {
    quote:
      'I love GoTu. This is hands down the best temp [platform] I have found that fills my needs almost instantly whenever I post a job request.',
    author: 'Donna K.',
    role: 'Office Manager',
  },
  {
    quote:
      '[I] would definitely recommend to any office in need. The professionalism of the Temps they send is exemplary.',
    author: 'Tanya J.',
    role: 'Regional Director',
  },
  {
    quote:
      'My experience with GoTu has been nothing short of phenomenal! My account manager always goes above and beyond to ensure that the needs for my practice are met.',
    author: 'Cecil H., DDS',
    role: 'Doctor',
  },
  {
    quote:
      'From the time I got on the phone with them, they were very professional. They were concerned about my needs and the dentist they sent out was amazing!',
    author: 'Dr. Sonya D.',
    role: 'Multi-Practice Owner',
  },
];
